// Module
var code = "<div style=position:relative;padding-bottom:56.25%;height:0><iframe iframe-url=$ctrl.playVideoRequest($ctrl.demoRequest) frameborder=0 webkitallowfullscreen=\"\" mozallowfullscreen=\"\" allowfullscreen=\"\" style=position:absolute;top:0;left:0;width:100%;height:100%></iframe></div>";
// Exports
module.exports = code;